module.exports = __webpack_public_path__ + "static/media/folder.6fb683b1.svg";